import { createFileRoute } from "@tanstack/react-router";
import { lazy } from "react";
import { useNancyFacility } from "@/routes/_authenticated/nancy/-lib/use-nancy-facility";

const PanelOrder = lazy(() =>
  import("@/routes/panel/-components/panel-order").then((module) => ({
    default: module.PanelOrder,
  })),
);

export const Route = createFileRoute("/panel/nancy/orders/$orderId")({
  head: () => ({ meta: [{ title: "Order | Nancy | People AI" }] }),
  component: PanelOrderRoute,
});

function PanelOrderRoute() {
  const { orderId } = Route.useParams();
  const { facilityId } = useNancyFacility();
  // A new order or a new community is a new page: nothing of the last one's stream survives.
  return <PanelOrder key={`${facilityId}:${orderId}`} threadId={orderId} />;
}
